<script lang="ts">
  import { firstRunBlocked } from '../state/here.svelte'
  import { layout } from '../state/layout.svelte'
  import { location, selectedBundle } from '../state/location.svelte'
  import FirstRun from './FirstRun.svelte'
  import StatusLine from './StatusLine.svelte'
  import AlertRows from './forecast/AlertRows.svelte'
  import DetailsGrid from './forecast/DetailsGrid.svelte'
  import ForecastHero from './forecast/ForecastHero.svelte'
  import HourlyStrip from './forecast/HourlyStrip.svelte'
  import NextHour from './forecast/NextHour.svelte'
  import WeekBars from './forecast/WeekBars.svelte'

  /**
   * The Forecast section, on both layouts (Phase 11 plan §1.2): the NOW block
   * and the place, the station line, the details strip, one row per alert,
   * the next hour, the next 24 hours and the week.
   *
   * The sections below the hero keep the last bundle through a failed load:
   * a stale forecast with an error line beats an empty panel. The hero, the
   * station line and the details name the point, so they read only its own.
   */

  let bundle = $derived(location.bundle)
  let own = $derived(selectedBundle())
</script>

{#if firstRunBlocked()}
  <!-- Nothing in the condition field until there is a place (round 2's 3.7). -->
  <FirstRun />
{:else}
  <ForecastHero phone={!layout.isDesktop} />
  <div class="status-row"><StatusLine current={own?.current ?? null} /></div>
  {#if own?.current}
    <div class="details-row"><DetailsGrid current={own.current} /></div>
  {/if}
{/if}
{#if bundle}
  <AlertRows alerts={bundle.alerts} />
  <NextHour timezone={bundle.location.timezone} />
  <HourlyStrip hourly={bundle.hourly} timezone={bundle.location.timezone} />
  <WeekBars forecast={bundle.forecast} timezone={bundle.location.timezone} />
{/if}

<style>
  .status-row,
  .details-row {
    padding: 14px var(--gutter) 0;
  }

  :global(.mobile) .status-row,
  :global(.mobile) .details-row {
    padding-top: 12px;
  }
</style>
